import React from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import StaffForm from './StaffForm';

export default function AddNewStaffModal({
  isOpen,
  onClose,
  onSubmit,
  successResponse,
  errorResponse,
}) {
  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      size="lg"
      backdrop={successResponse ? true : 'static'}
      keyboard
      className="model-form staff-modal staff-modal-create"
    >
      <ModalHeader className="header-form">Add Staff Member</ModalHeader>
      <ModalBody>
        <StaffForm
          onSubmit={onSubmit}
          closeModal={onClose}
          successResponse={successResponse}
          errorResponse={errorResponse}
        />
      </ModalBody>
    </Modal>
  );
}
